var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-approve-wrapper icon-wrapper"},[_c('img',{staticClass:"btn-approve-icon app-icon",attrs:{"src":(_vm.publicPath + "/img/btn-approve.png"),"alt":"approve icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }